import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { RankingPopoverPage } from './ranking-popover';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    IonicModule.forRoot(),
  ],
  declarations: [RankingPopoverPage],
})
export class RankingPopoverPageModule { }
